export default { error: {}, info: {}, success: {}, selectedMitraDetails: {}, isAPIProgress: false, selectedJobDescription: {}, jobListingCarouselContent: {} };
